import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import {
  createTranslations,
  defaultTranslations,
  LocationTranslations,
} from './location.translations';
import { Location } from './location.interface';

@Component({
  selector: 'zelis-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationComponent {
  @HostBinding() class = 'zelis-dls';
  @Input() public altFormat = false;
  @Input() public location!: Location;
  @Input() public showDistance = false;
  @Input() public getDirectionsAction!: any;
  @Input() public medGroupEnabled = false;
  @Input() public searchTerm?: string = '';
  @Input() public showDirections = true;
  @Input() public showIcon = false;
  @Input()
  get translations(): LocationTranslations {
    return this._translations;
  }
  set translations(value: Partial<LocationTranslations>) {
    this._translations = createTranslations(defaultTranslations, value);
  }
  private _translations: LocationTranslations = defaultTranslations;

  public getDirections(event: MouseEvent): void {
    event.preventDefault();
    if (this.getDirectionsAction) {
      const dest = this.setOneLineAddress(this.location);
      this.getDirectionsAction(dest);
    }
  }

  public distanceTranslation(distance: string | null): string {
    return distance === '1.0'
      ? this.translations.milesAwaySingular
      : this.translations.milesAway;
  }

  public trackByFn(index: number, group: any): string {
    return group.name;
  }

  private setOneLineAddress(location: Location): string {
    let address = '';
    if (location?.addr_line1) {
      address += `${location.addr_line1}, `;
      if (location?.addr_line2) {
        address += `${location.addr_line2}, `;
      }
      if (location?.city && location.state && location.postal_code) {
        address += `${location.city}, ${location.state} ${location.postal_code}`;
      }
    }
    return address;
  }
}
